export default "__VITE_ASSET__BxAx4HQz__"